import { render, staticRenderFns } from "./leader-board.vue?vue&type=template&id=b00904d6&scoped=true&"
import script from "./leader-board.vue?vue&type=script&lang=ts&"
export * from "./leader-board.vue?vue&type=script&lang=ts&"
import style0 from "./leader-board.vue?vue&type=style&index=0&id=b00904d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00904d6",
  null
  
)

export default component.exports